<template>
  <v-radio-group
    v-bind="this.$attrs"
    @change="$emit('change', type)"
    v-model="type"
    mandatory
    row
    class="shrink mt-0 pt-0"
    hide-details="auto"
  >
    <v-radio label="Nghỉ có phép" hide-details value="valid"></v-radio>
    <v-radio label="Nghỉ không phép" hide-details value="invalid"></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: ''
  }),
  props: {
    diligenceType: {
      type: String,
      default: 'valid'
    }
  },
  created() {
    this.type = this.diligenceType
    this.$emit('change', this.type)
  },
  watch: {
    diligenceType(newVal) {
      this.type = newVal
    }
  }
}
</script>
